import {difference, forEach, get, keys} from "lodash-es";
import {BaseComponent} from "@wms/components";
import {Injectable} from "@angular/core";
let markups: {[key: string]: any} = {
    'blank':
      '<wm-page>' +
      '<wm-content>' +
      '<wm-page-content columnwidth="12"></wm-page-content>' +
      '</wm-content>' +
      '</wm-page>'
  },
  templates: {[key: string]: any} = {
    'DEFAULT' : '<wm-page>' +
      '<wm-header content="header"></wm-header>' +
      '<wm-top-nav content="topnav"></wm-top-nav>' +
      '<wm-content>' +
      '<wm-left-panel columnwidth="2" content="leftnav"></wm-left-panel>' +
      '<wm-page-content columnwidth="8"></wm-page-content>' +
      '<wm-right-panel columnwidth="2" content="rightnav"></wm-right-panel>' +
      '</wm-content>' +
      '<wm-footer content="footer"></wm-footer>' +
      '</wm-page>',
    'MOBILE'  : '<wm-page>' +
      '<wm-left-panel content="leftnav"></wm-left-panel>' +
      '<wm-mobile-navbar></wm-mobile-navbar>' +
      '<wm-content>' +
      '<wm-page-content columnwidth="12"></wm-page-content>' +
      '</wm-content>' +
      '<wm-mobile-tabbar></wm-mobile-tabbar>' +
      '</wm-page>',
    'NATIVE_MOBILE' :
      '<wm-page>' +
      '<wm-left-panel content="leftnav"></wm-left-panel>' +
      '<wm-mobile-navbar></wm-mobile-navbar>' +
      '<wm-content>' +
      '<wm-page-content columnwidth="12"></wm-page-content>' +
      '</wm-content>' +
      '<wm-mobile-tabbar></wm-mobile-tabbar>' +
      '</wm-page>',
    'WEB_PRISM': {
      'default':
        '<wm-page>' +
        '<wm-content>' +
        '<wm-page-content columnwidth="12"></wm-page-content>' +
        '</wm-content>' +
        '</wm-page>',
      'oneColumnWithoutTopNav':
        '<wm-page>' +
        '<wm-header content="header"></wm-header>' +
        '<wm-content>' +
        '<wm-page-content columnwidth="12"></wm-page-content>' +
        '</wm-content>' +
        '<wm-footer content="footer"></wm-footer>' +
        '</wm-page>',
      'oneColumnWithTopNav':
        '<wm-page>' +
        '<wm-header content="header"></wm-header>' +
        '<wm-top-nav content="topnav"></wm-top-nav>' +
        '<wm-content>' +
        '<wm-page-content columnwidth="12"></wm-page-content>' +
        '</wm-content>' +
        '<wm-footer content="footer"></wm-footer>' +
        '</wm-page>',
      // 'twoColumnWithoutTopNavLeftclipped':
      //   '<wm-page>' +
      //   '<wm-header content="header"></wm-header>' +
      //   '<wm-content>' +
      //   '<wm-left-panel columnwidth="2" content="leftnav" navtype="rail" navheight="clipped"></wm-left-panel>' +
      //   '<wm-page-content columnwidth="8"></wm-page-content>' +
      //   '</wm-content>' +
      //   '<wm-footer content="footer"></wm-footer>' +
      //   '</wm-page>',
      'twoColumnWithoutTopNavLeftfull':
        '<wm-page>' +
        '<wm-left-panel columnwidth="2" content="leftnav" navtype="rail" navheight="full"></wm-left-panel>' +
        '<wm-content>' +
        '<wm-header content="header"></wm-header>' +
        '<wm-page-content columnwidth="10"></wm-page-content>' +
        '<wm-footer content="footer"></wm-footer>' +
        '</wm-content>' +
        '</wm-page>',
      // 'twoColumnWithTopNavLeftclipped':
      //   '<wm-page>' +
      //   '<wm-header content="header"></wm-header>' +
      //   '<wm-top-nav content="topnav"></wm-top-nav>' +
      //   '<wm-content>' +
      //   '<wm-left-panel columnwidth="2" content="leftnav" navtype="rail" navheight="clipped"></wm-left-panel>' +
      //   '<wm-page-content columnwidth="8"></wm-page-content>' +
      //   '</wm-content>' +
      //   '<wm-footer content="footer"></wm-footer>' +
      //   '</wm-page>',
      'twoColumnWithTopNavLeftfull':
        '<wm-page>' +
        '<wm-left-panel columnwidth="2" content="leftnav" navtype="rail" navheight="full"></wm-left-panel>' +
        '<wm-content>' +
        '<wm-header content="header"></wm-header>' +
        '<wm-top-nav content="topnav"></wm-top-nav>' +
        '<wm-page-content columnwidth="10"></wm-page-content>' +
        '<wm-footer content="footer"></wm-footer>' +
        '</wm-content>' +
        '</wm-page>',
      // 'threeColumnWithoutTopNavLeftRightclipped':
      //   '<wm-page>' +
      //   '<wm-header content="header"></wm-header>' +
      //   '<wm-content>' +
      //   '<wm-left-panel columnwidth="2" content="leftnav" navtype="rail" navheight="clipped"></wm-left-panel>' +
      //   '<wm-page-content columnwidth="8"></wm-page-content>' +
      //   '<wm-right-panel columnwidth="2" content="rightnav" navtype="rail" navheight="clipped"></wm-right-panel>' +
      //   '</wm-content>' +
      //   '<wm-footer content="footer"></wm-footer>' +
      //   '</wm-page>',
      'threeColumnWithoutTopNavLeftRightfull':
        '<wm-page>' +
        '<wm-left-panel columnwidth="2" content="leftnav" navtype="rail" navheight="full"></wm-left-panel>' +
        '<wm-content>' +
        '<wm-header content="header"></wm-header>' +
        '<wm-page-content columnwidth="8"></wm-page-content>' +
        '<wm-footer content="footer"></wm-footer>' +
        '</wm-content>' +
        '<wm-right-panel columnwidth="2" content="rightnav" navtype="rail" navheight="full"></wm-right-panel>' +
        '</wm-page>',
      // 'threeColumnWithTopNavLeftRightClipped':
      //   '<wm-page>' +
      //   '<wm-header content="header"></wm-header>' +
      //   '<wm-top-nav content="topnav"></wm-top-nav>' +
      //   '<wm-content>' +
      //   '<wm-left-panel columnwidth="2" content="leftnav" navtype="rail" navheight="clipped"></wm-left-panel>' +
      //   '<wm-page-content columnwidth="8"></wm-page-content>' +
      //   '<wm-right-panel columnwidth="2" content="rightnav" navtype="rail" navheight="clipped"></wm-right-panel>' +
      //   '</wm-content>' +
      //   '<wm-footer content="footer"></wm-footer>' +
      //   '</wm-page>',
      'threeColumnWithTopNavLeftRightFull':
        '<wm-page>' +
        '<wm-left-panel columnwidth="2" content="leftnav" navtype="rail" navheight="full"></wm-left-panel>' +
        '<wm-content>' +
        '<wm-header content="header"></wm-header>' +
        '<wm-top-nav content="topnav"></wm-top-nav>' +
        '<wm-page-content columnwidth="8"></wm-page-content>' +
        '<wm-footer content="footer"></wm-footer>' +
        '</wm-content>' +
        '<wm-right-panel columnwidth="2" content="rightnav" navtype="rail" navheight="full"></wm-right-panel>' +
        '</wm-page>'
          }
  },
  layouts: {[key: string]: any} = {
    'DEFAULT' : {
      'blank': {
        'id': 'blank',
        'name': 'Blank Layout',
        'description': 'Blank Canvas',
        'details': []
      },
      'oneColumnWithoutTopNav': {
        'id': 'oneColumnWithoutTopNav',
        'name': 'One Column Layout Without topnav',
        'description': 'Header, Content, Footer',
        'details': ['HEADER', 'FOOTER']
      },
      'oneColumnWithTopNav': {
        'id': 'oneColumnWithTopNav',
        'name': 'One Column Layout',
        'description': 'Header, Topnav, Content, Footer',
        'details': ['HEADER', 'TOPNAV', 'FOOTER']
      },
      'twoColumnWithoutTopNav': {
        'id': 'twoColumnWithoutTopNav',
        'name': 'Two Column Layout without topnav',
        'description': 'Header, Content, Leftnav, Footer',
        'details': ['HEADER', 'LEFTNAV', 'FOOTER']
      },
      'twoColumnWithTopNav': {
        'id': 'twoColumnWithTopNav',
        'name': 'Two Column Layout',
        'description': 'Header, Topnav, Leftnav, Content, Footer',
        'details': ['HEADER', 'TOPNAV', 'LEFTNAV', 'FOOTER']
      },
      'threeColumnWithoutTopNav': {
        'id': 'threeColumnWithoutTopNav',
        'name': 'Three Column Layout without topnav',
        'description': 'Header, Leftnav, Content, Rightnav, Footer',
        'details': ['HEADER', 'LEFTNAV', 'RIGHTNAV', 'FOOTER']
      },
      'threeColumnWithTopNav': {
        'id': 'threeColumnWithTopNav',
        'name': 'Three Column Layout',
        'description': 'Header, Topnav, Leftnav, Content, Rightnav, Footer',
        'details': ['HEADER', 'TOPNAV', 'LEFTNAV', 'RIGHTNAV', 'FOOTER']
      }
    },
    'MOBILE' : {
      'mobileBlank': {
        'id': 'mobileBlank',
        'name': 'Blank Layout',
        'description': 'Blank layout',
        'details': []
      },
      'mobileOneColumnWithTopNav': {
        'id': 'mobileOneColumnWithTopNav',
        'name': 'One column layout with top navbar.',
        'description': 'One column layout with top navbar',
        'details': ['NAVBAR']
      },
      'mobileTwoColumnWithTopNav': {
        'id': 'mobileTwoColumnWithTopNav',
        'name': 'Two column layout with top navbar',
        'description': 'Two column layout with top navbar.',
        'details': ['NAVBAR', 'LEFTNAV']
      },
      'mobileOneColumnWithTopNavAndTabbar': {
        'id': 'mobileOneColumnWithTopNavAndTabbar',
        'name': 'One column layout with top navbar and tabbar.',
        'description': 'One column layout with top navbar and tabbar.',
        'details': ['NAVBAR', 'TABBAR']
      },
      'mobileTwoColumnWithTopNavAndTabbar': {
        'id': 'mobileTwoColumnWithTopNavAndTabbar',
        'name': 'Two column layout with top navbar and tabbar.',
        'description': 'Two column layout with top navbar and tabbar.',
        'details': ['NAVBAR', 'TABBAR', 'LEFTNAV']
      }
    },
    'NATIVE_MOBILE' : {
      'mobileBlank': {
        'id': 'mobileBlank',
        'name': 'Blank Layout',
        'description': 'Blank layout',
        'details': []
      },
      'mobileOneColumnWithTopNav': {
        'id': 'mobileOneColumnWithTopNav',
        'name': 'One column layout with top navbar.',
        'description': 'One column layout with top navbar',
        'details': ['NAVBAR']
      },
      'mobileTwoColumnWithTopNav': {
        'id': 'mobileTwoColumnWithTopNav',
        'name': 'Two column layout with top navbar',
        'description': 'Two column layout with top navbar.',
        'details': ['NAVBAR', 'LEFTNAV']
      },
      'mobileOneColumnWithTopNavAndTabbar': {
        'id': 'mobileOneColumnWithTopNavAndTabbar',
        'name': 'One column layout with top navbar and tabbar.',
        'description': 'One column layout with top navbar and tabbar.',
        'details': ['NAVBAR', 'TABBAR']
      },
      'mobileTwoColumnWithTopNavAndTabbar': {
        'id': 'mobileTwoColumnWithTopNavAndTabbar',
        'name': 'Two column layout with top navbar and tabbar.',
        'description': 'Two column layout with top navbar and tabbar.',
        'details': ['NAVBAR', 'TABBAR', 'LEFTNAV']
      }
    },
    'WEB_PRISM': {
      'blank': {
        'id': 'blank',
        'name': 'Blank Layout',
        'description': 'Blank layout',
        'details': []
      },
      'oneColumnWithoutTopNav': {
        'id': 'oneColumnWithoutTopNav',
        'name': 'One Column Layout Without Topnav',
        'description': 'Header, Content, Footer',
        'details': ['HEADER', 'FOOTER']
      },
      'oneColumnWithTopNav': {
        'id': 'oneColumnWithTopNav',
        'name': 'One Column Layout',
        'description': 'Header, Topnav, Content, Footer',
        'details': ['HEADER', 'TOPNAV', 'FOOTER']
      },
      // 'twoColumnWithoutTopNavLeftclipped': {
      //   'id': 'twoColumnWithoutTopNavLeftclipped',
      //   'name': 'Two Column Layout Without Topnav (Left Clipped)',
      //   'description': 'Header, Leftnav (clipped), Content, Footer',
      //   'details': ['HEADER', 'LEFTNAV', 'FOOTER']
      // },
      'twoColumnWithoutTopNavLeftfull': {
        'id': 'twoColumnWithoutTopNavLeftfull',
        'name': 'Two Column Layout Without Topnav (Left Full)',
        'description': 'Header, Leftnav, Content, Footer',
        'details': ['HEADER', 'LEFTNAV', 'FOOTER']
      },
      // 'twoColumnWithTopNavLeftclipped': {
      //   'id': 'twoColumnWithTopNavLeftclipped',
      //   'name': 'Two Column Layout With Topnav (Left Clipped)',
      //   'description': 'Header, Topnav, Leftnav (clipped), Content, Footer',
      //   'details': ['HEADER', 'TOPNAV', 'LEFTNAV', 'FOOTER']
      // },
      'twoColumnWithTopNavLeftfull': {
        'id': 'twoColumnWithTopNavLeftfull',
        'name': 'Two Column Layout With Topnav (Left Full)',
        'description': 'Header, Topnav, Leftnav, Content, Footer',
        'details': ['HEADER', 'TOPNAV', 'LEFTNAV', 'FOOTER']
      },
      // 'threeColumnWithoutTopNavLeftRightclipped': {
      //   'id': 'threeColumnWithoutTopNavLeftRightclipped',
      //   'name': 'Three Column Layout Without Topnav (Left & Right Clipped)',
      //   'description': 'Header, Leftnav (clipped), Content, Rightnav (clipped), Footer',
      //   'details': ['HEADER', 'LEFTNAV', 'RIGHTNAV', 'FOOTER']
      // },
      'threeColumnWithoutTopNavLeftRightfull': {
        'id': 'threeColumnWithoutTopNavLeftRightfull',
        'name': 'Three Column Layout Without Topnav (Left & Right Full)',
        'description': 'Header, Leftnav, Content, Rightnav, Footer',
        'details': ['HEADER', 'LEFTNAV', 'RIGHTNAV', 'FOOTER']
      },
      // 'threeColumnWithTopNavLeftRightClipped': {
      //   'id': 'threeColumnWithTopNavLeftRightClipped',
      //   'name': 'Three Column Layout With Topnav (Left & Right Clipped)',
      //   'description': 'Header, Topnav, Leftnav (clipped), Content, Rightnav (clipped), Footer',
      //   'details': ['HEADER', 'TOPNAV', 'LEFTNAV', 'RIGHTNAV', 'FOOTER']
      // },
      'threeColumnWithTopNavLeftRightFull': {
        'id': 'threeColumnWithTopNavLeftRightFull',
        'name': 'Three Column Layout With Topnav (Left & Right Full)',
        'description': 'Header, Topnav, Leftnav, Content, Rightnav, Footer',
        'details': ['HEADER', 'TOPNAV', 'LEFTNAV', 'RIGHTNAV', 'FOOTER']
      }
    }
  },
  SELECTOR = {
    'DEFAULT' : {
      'HEADER'    : 'wm-page > wm-header',
      'TOPNAV'    : 'wm-page > wm-top-nav',
      'LEFTNAV'   : 'wm-page > wm-content > wm-left-panel',
      'RIGHTNAV'  : 'wm-page > wm-content > wm-right-panel',
      'FOOTER'    : 'wm-page > wm-footer'
    },
    'MOBILE' : {
      'LEFTNAV'   : 'wm-page > wm-left-panel',
      'NAVBAR'    : 'wm-page > wm-mobile-navbar',
      'TABBAR'    : 'wm-page > wm-mobile-tabbar'
    },
    'NATIVE_MOBILE' : {
      'LEFTNAV'   : 'wm-page > wm-left-panel',
      'NAVBAR'    : 'wm-page > wm-mobile-navbar',
      'TABBAR'    : 'wm-page > wm-mobile-tabbar'
    },
    'WEB_PRISM': {
      'HEADER': 'wm-page > wm-header',
      'TOPNAV': 'wm-page > wm-top-nav',
      'LEFTNAV': 'wm-page > wm-left-panel',
      'RIGHTNAV': 'wm-page > wm-right-panel',
      'FOOTER': 'wm-page > wm-footer'
    }
  };
@Injectable({
  providedIn: 'root'
})
export class PageLayoutsService extends BaseComponent {
  constructor() {
    super();
  }
   private findComponentColWidth(pageMarkup: JQuery<HTMLElement>, component: any) {
    const ele = pageMarkup.find(component);
    const w = ele.attr('columnwidth') || '';
    return ele.length > 0 ? parseInt(w, 10) : 0;
  }
   private findAndReplaceElement(selector: string, oldPage: JQuery<HTMLElement>, newPage: JQuery<HTMLElement>) {
    const ele = newPage.find(selector),
    children = ele.children(),
    oldEle = oldPage.find(selector);
    if (oldEle.length > 0) {
      if (children.length > 0) {
        forEach(children, (child) => {
          this.findAndReplaceElement(selector + ' >' + child.tagName, oldPage, newPage);
        });
        oldEle.empty();
        oldEle.append(ele.children());
      }
      oldEle.insertBefore(ele);
      ele.remove();
    }
  }
  getPageLayouts() {
    const platformType = this.projectService.getDetails().platformType.toUpperCase();
    const isPrismTemplate = this.projectService.getProjectTemplate() === 'PRISM';
    const appLayouts = platformType === 'WEB' && isPrismTemplate ? layouts['WEB_PRISM'] : layouts[platformType] || layouts['DEFAULT'];
    return Object.values(appLayouts);
  };
  getLayoutDetails(layoutType: string) {
    const platformType = this.projectService.getDetails().platformType.toUpperCase();
    const isPrismTemplate = this.projectService.getProjectTemplate() === 'PRISM';
    const appLayouts = platformType === 'WEB' && isPrismTemplate ? layouts['WEB_PRISM'] : layouts[platformType] || layouts['DEFAULT'];
    return appLayouts[layoutType]?.details || [];
  };
  getLayoutMarkup(layoutType: string) {
    return markups[layoutType] || '';
  };
  switchLayout(pageMarkup: any, layout: any) {
   const platformType = this.projectService.getDetails().platformType.toUpperCase();
    const isPrismTemplate = this.projectService.getProjectTemplate() === 'PRISM';
    const templateKey = platformType === 'WEB' && isPrismTemplate ? 'WEB_PRISM' : platformType;
    // Get correct markup
    const newPageMarkup =
      templateKey === 'WEB_PRISM'
        ? templates['WEB_PRISM'][layout.id] || templates['WEB_PRISM'].default
        : templates[templateKey] || templates['DEFAULT'];
    const newPage = $('<div></div>').html(newPageMarkup);
    const oldPage = $('<div></div>').html(pageMarkup.html());

    // Define layout slot tags (these are part of the layout structure and will be replaced)
    // Everything else should be preserved
    const layoutSlotTags = new Set([
      'wm-header',
      'wm-top-nav',
      'wm-left-panel',
      'wm-right-panel',
      'wm-footer',
      'wm-content',
      'wm-page-content',
      'wm-mobile-navbar',
      'wm-mobile-tabbar'
    ]);

    // Extract all non-layout elements from old page (direct children of wm-page only)
    // This includes ALL dialogs (even multiple of same type), custom elements, and any other markup
    const oldPageElement = oldPage.find('> wm-page');
    const nonLayoutElements: JQuery<HTMLElement>[] = [];
    
    oldPageElement.children().each((_, el) => {
      const tagName = el.tagName.toLowerCase();
      // Preserve everything that is NOT a layout tag (preserve ALL instances)
      if (!layoutSlotTags.has(tagName)) {
        nonLayoutElements.push($(el).clone());
      }
    });

    const layoutConfig = get(SELECTOR, templateKey) || SELECTOR.DEFAULT;
    const componentsToRemove = difference(keys(layoutConfig), layout.details);
    this.findAndReplaceElement('> wm-page', oldPage, newPage);
    // Remove unused components
    forEach(componentsToRemove, (component) => {
      newPage.find(layoutConfig[component]).remove();
    });
    // Compute page content width
    let pageContentWidth = 12;
    if (!this.projectService.isMobileApplicationType()) {
      pageContentWidth =
        12 - this.findComponentColWidth(newPage, layoutConfig.LEFTNAV) -
        this.findComponentColWidth(newPage, layoutConfig.RIGHTNAV);
    }
    const pageContent = newPage.find('> wm-page > wm-content > wm-page-content');
    pageContent.attr('columnwidth', pageContentWidth);
    // Append old views safely
    const oldViews = oldPage.find('wm-view');
    // pageContent.empty();
    pageContent.append(oldViews);
    // Remove widgetId attributes
    newPage.find('[widgetid]').removeAttr('widgetid');
    // Preserve all non-layout elements: append ALL instances to new page (direct children of wm-page)
    // This includes ALL dialogs (even multiple of same type), custom elements, and any other markup
    const newPageElement = newPage.find('> wm-page');
    forEach(nonLayoutElements, (element) => {
      // Append all instances - no duplicate check needed since we're preserving everything from old page
      newPageElement.append(element);
    });

    return newPage;
  };
}
